/**
 * Block is used on framework/vc-elements/careers/hero-careers-video.php
 *
 * @returns {{isPlaying: boolean, toggleVideo(): void}}
 */
export default () => ({
    isPlaying: false,

    toggleVideo() {
        let video = document.getElementById('video');

        if (video !== null) {
            if (this.isPlaying)
                video.pause();
            else
                video.play();

            this.isPlaying = !this.isPlaying;
        }
    }
})